import { Box, Typography } from '@mui/material';

import { useTranslate } from '@/hooks/useTranslate';

import {
  TaxResidencyInfoItem,
  TaxResidencyInfoList,
} from './TaxResidencyTooltip.styled';

type TaxResidencyTooltipContentProps = {
  maxSelections: number;
};

export const TaxResidencyTooltipContent = ({
  maxSelections,
}: TaxResidencyTooltipContentProps) => {
  const { t } = useTranslate();

  return (
    <Box margin={1}>
      <Typography variant="body2">
        {t('createNewAccount.addressPage.form.hintIconTaxInformation.heading')}
      </Typography>

      <TaxResidencyInfoList>
        <TaxResidencyInfoItem>
          <Typography variant="body2">
            {t(
              'createNewAccount.addressPage.form.hintIconTaxInformation.listPoint1',
            )}
          </Typography>
        </TaxResidencyInfoItem>
        <TaxResidencyInfoItem>
          <Typography variant="body2">
            {t(
              'createNewAccount.addressPage.form.hintIconTaxInformation.listPoint2',
            )}
          </Typography>
        </TaxResidencyInfoItem>
      </TaxResidencyInfoList>

      <Typography variant="body2">
        {t(
          'createNewAccount.addressPage.form.hintIconTaxInformation.subHeading',
        )}
      </Typography>

      <Typography variant="body2" fontWeight="bold" mt={1}>
        {t('createNewAccount.addressPage.form.hintIconTaxInformation.note', {
          taxSelectionLimit: String(maxSelections).padStart(2, '0'),
        })}
      </Typography>
    </Box>
  );
};
